angular.module('ui2.0Directives')
    .directive('preferences', ['$rootScope', '$http', '$location','$q', function ($rootScope, $http, $location,$q) {
        return {
            restrict: "E",
            templateUrl: $rootScope.createHtmlUrl("ui2.0/directiveTemplates/preferences.html"),
            link: function ($scope, element, attrs) {
                $scope.viewType = 'byMe';
                $scope.viewTypeToSave = 'private'
                $scope.systemDefault = false;
                $scope.saveViewLiText = intl_msg[27944];
                $scope.editViewObj = null;
                $scope.urlController = $scope.isReportFilter?"reportRenderer":"listRenderer"
                $scope.saveMode = true;
                $scope.showLimitExceedMessage = "";
                $scope.searchText = "";
                $scope.defaultView = {};
                let alreadySavedView = false;
                $scope.bulkThroughJourney = !$rootScope.updateBulkListing;
            $scope.firstLoad = false;
                $scope.radio = {
                    saveType: {'value': 'private'},
                    viewType: {'value': 'byMe'}
                }
                $scope.nameToSave = {"value": ""};
                if (window.contractId) {
                    let contractId = window.contractId;
                } else {
                    let contractId = "";
                }
                if (window.relationId) {
                    let relationId = window.relationId;
                } else {
                    let relationId = "";
                }
                if (window.vendorId) {
                    let vendorId = window.vendorId;
                } else {
                    let vendorId = "";
                }
                $scope.$on('updateViewListing', function (event, data,filterCallback) {
                    $scope.updateViewListing(data, true, true,filterCallback);
                });
                $scope.$on('statModifiedFunc', function (event) {
                    $scope.statModifiedFunc();
                });
                $scope.$on('updateSetting', function (event) {
                    $scope.updateSetting(event, true);
                });
                $scope.$on('cancelSetting', function (event) {
                    $scope.cancelSetting(event);
                });
                $scope.statModifiedFunc = () => {
                    if (_.isEmpty($scope.currentView)) {
                        $scope.myViewChanged = false;
                    } else {
                        var publicVisibility = ["Shared By Me", "Shared With Me"].indexOf($scope.currentView.visibility) > -1 ? true : false;
                        var viewType = $scope.currentView.visibility;
                        if ((publicVisibility && viewType == "Shared With Me")) {
                            $scope.myViewChanged = false;
                        } else {
                            $scope.myViewChanged = true;
                        }
                    }
                    // angular.element(".modifiedStat").show();
                    $scope.viewModified = true;
                }
                $scope.updateViewListing = (data, changeDefault, firstLoad,filterCallback) => {
                    $scope.firstLoad = firstLoad;
                    let systemDefaultPreferred = true;
                    $scope.noByMeViews = true;
                    angular.element('listingPanelLeft').find(".savedViewDD li:not('.noViews, .resetView')").remove();
                    let createdByViewsLength = data.filter(function (view) {
                        return view.visibility != "Shared With Me"
                    }).length;
                    if (createdByViewsLength) {
                        $scope.noByMeViews = false;
                    }
                    $scope.allViews = data;
                    $scope.idInView = null;
                    $scope.prevObj = null;
                    $scope.privateCollapseIconClass = "icon-down-arrow";
                    $scope.publicCollapseIconClass = "icon-down-arrow";
                    $scope.allViews.sort((view1, view2) => view2.isdefault - view1.isdefault);
                    let view = $scope.allViews.find(function (view) {
                        return view.isdefault;
                    });


                    if (firstLoad && !_.isEmpty(view)) {
                        if ($scope.initFilters){
                            $scope.initFilters().then(function(){
                                $rootScope.loadClauseLibraryDefInstance && $rootScope.loadClauseLibraryDefInstance.resolve("Filter compiled!");
                                filterCallback &&  filterCallback();
                            });
                        }
                    }
                    if (changeDefault) {
                        if (_.isEmpty(view)) {
                            $scope.systemDefault = true;
                            $scope.showResetView = false;
                            $scope.defaultView = {};
                        } else {
                            $scope.systemDefault = false;
                            $scope.defaultView = view;
                            $scope.showResetView = false;

                            if (firstLoad) {
                                $scope.currentView = view;
                                if ($location.search().insightComputationId) {
                                    $scope.currentView = {};
                                }
                                $scope.showResetView = false;
                            }
                        }
                    }


                    $scope.showLimitExceedMessage = createdByViewsLength >= 40 ? intl_msg[28988].replace("%s", "40") : "";

                }
                $scope.getPinTitle = (view) => {
                    return (view.pinned) ? intl_msg[25736] : intl_msg[25735];
                }
                $scope.setPreferredView = (viewType) => {
                    if (viewType == "byMe") {
                        $scope.viewType = 'byMe';
                        // angular.element('#byMeViewBtnRadio').prop("checked", true);
                        $scope.radio.viewType.value = 'byMe';
                    } else {
                        $scope.viewType = 'others';
                        // angular.element('#othersViewBtnRadio').prop("checked", true);
                        $scope.radio.viewType.value = 'others';
                    }
                }
                $scope.toggleHoverState = (e, mouseEnter) => {
                    let element = angular.element(e.target);
                    if (mouseEnter) {
                        element.addClass('hoverState');
                    } else {
                        element.removeClass('hoverState');
                    }
                }
                $scope.toggleDropDown = (e, viewId) => {
                    e.stopPropagation();
                    if (!$scope.prevObj) {
                        angular.element("li[data-mod-id=" + viewId + "]").find('.toggleDropDown').show();
                    } else {
                        if (viewId == $scope.prevObj) {
                            angular.element("li[data-mod-id=" + viewId + "]").find('.toggleDropDown').toggle();
                        } else {
                            angular.element("li[data-mod-id=" + $scope.prevObj + "]").find('.toggleDropDown').hide();
                            angular.element("li[data-mod-id=" + viewId + "]").find('.toggleDropDown').show();
                        }
                    }
                    $scope.prevObj = viewId;
                    let heightDiff = ($("#viewdd").offset().top + $("#viewdd").height()) - ($("li[data-mod-id=" + $scope.prevObj + "]").offset().top + $("li[data-mod-id=" + $scope.prevObj + "]").outerHeight());
                    if (angular.element(".by-me").scrollTop() + 80 < angular.element(".by-me").innerHeight()) {
                        if (heightDiff && heightDiff < 0) {
                            let scrollAmount = 100 - heightDiff;
                            setTimeout(function () {
                                angular.element(".by-me").stop().animate({scrollTop: scrollAmount}, 'slow');
                            });

                        } else if (heightDiff && heightDiff < 80) {
                            let scrollAmount = 100 - heightDiff;
                            setTimeout(function () {
                                angular.element(".by-me").stop().animate({scrollTop: scrollAmount}, 'slow');
                            });

                        }
                    }


                }

                $scope.getClassForLi = (view) => {
                    return view.isdefault ? 'isDefaultView' : '';
                }

                $scope.privateView = (view) => {
                    return view.visibility === 'My View';
                }

                $scope.publicView = (view) => {
                    return view.visibility === 'Shared By Me';
                }

                $scope.othersView = (view) => {
                    return view.visibility === 'Shared With Me';
                }

                $scope.switchPrivateDiv = (e) => {
                    e.stopPropagation();
                    $scope.privateCollapseIconClass = $scope.privateCollapseIconClass === 'icon-down-arrow' ? 'icon-Right-Arrow' : 'icon-down-arrow';
                    // angular.element(e.target).find("#privateDiv").toggle();
                    angular.element("#privateDiv").toggle();
                }

                $scope.switchPublicDiv = (e) => {
                    e.stopPropagation();
                    $scope.publicCollapseIconClass = $scope.publicCollapseIconClass === 'icon-down-arrow' ? 'icon-Right-Arrow' : 'icon-down-arrow';
                    angular.element("#publicDiv").toggle();
                }

            $scope.loadView = (e,view) =>{
                if(e){
                    e.stopPropagation();
                    if(angular.element(e.currentTarget).hasClass('disabledClick') && !$rootScope.showPreferredViewForcefully){
                        return;
                    }
                }
                $scope.resetDocTreeSaveBanner(false);
                $scope.showSaveFiltersDD = false;
                $scope.initialPrefViewFilterDataObj = {};
                $rootScope.insightsCollapsed = true;
                $rootScope.savedViewLoaded = true;
                $scope.searchText = "";
                if((angular.element(".viewSection").hasClass('editMode'))){
                    angular.element(".editMode").addClass("selected");
                }
                ;if(!(angular.element(".viewSection").hasClass('editMode'))){
                    angular.element(".viewSection").removeClass("selected");
                }
                ;angular.element("#viewdd").css({"opacity":0,"visibility":"hidden","display":"none","z-index":-1
                });if(typeof BU != "undefined" && BU.cancelAction && angular.element(e.currentTarget).closest("#bulkPlaceHolderList").length == 0) {
                    BU.cancelAction(true); // Case for resetting the bulk action state
                }
                if(!view){
                    $scope.currentView = {};
                    $scope.showResetView = false;
                    angular.element(".resetView").addClass('disabledClick');
                    commonUtil.unPinnedForSystemDefaultView();
                    setTimeout(function(){
                         angular.element(".reset ").each(function () {
                             angular.element(this).click();
                         });
                    });
                    return;
                } else{
                    $scope.currentView = view;

                    if($scope.defaultView && $scope.defaultView.id == $scope.currentView.id){
                        $scope.showResetView = false;
                    } else{
                        $scope.showResetView = true;
                    }
                }
                angular.element(".disabledClick").removeClass("disabledClick");
                angular.element("li[data-mod-id=" + view.id + "]").addClass('disabledClick');
                (e && e.originalEvent) ? setTimeout(function(){ $scope.$emit("listing skeleton toggle", true, false) }) : null;
                commonUtil.markActiveView(view.id);
                let publicVisibility = ["Shared By Me", "Shared With Me"].indexOf(view.visibility) > -1 ? true : false;
                let url = apiVersioning.getApiDynamicVersion($scope.urlController) + listId + "/userListMetaData?preferenceId=" + view.id + "&contractId=" + contractId + "&publicVisibility=" + publicVisibility;
                $http.post(url).then(function successCallback(response) {
                    let data = response.data;
                    window.documentTreeConfig.filterOrSaveViewApplied = true;
                    if(data && data.filterJson == "null"){
                        window.systemWarning("View Corrupted filterJson",data);
                        data.filterJson = stringify_datatable_json(true);
                    }
                    window.prefMetaDataAvailable = userPref;
                    userPref = $scope.appendMissingFilters(data);
                    defaultFilterLayoutData= userPref.filterJson ? sJq.$.parseJSON(userPref.filterJson):{};
                    $scope.initialPrefViewFilterDataObj = defaultFilterLayoutData.filterMap.filterJson;
                    let filterJson = $.parseJSON(userPref.filterJson);
                    if ($scope.isReportFilter && filterJson.filterMap && filterJson.filterMap.filterJson) {
                        window.filterDataJson = $.extend(true, {}, filterJson.filterMap.filterJson);
                    }
                    $scope.searchTextForDT = {value:'',debounce:500};
                    if(filterJson.filterMap && typeof filterJson.filterMap.searchName != "undefined") {
                        $scope.searchTextForDT = {value:filterJson.filterMap.searchName,debounce:500};
                    }

                    if (data == null || data == "") {
                        stopLoader();
                        Toaster.create(intl_msg[7750],{iconClass:"icon-Information_filled"});
                        return;
                    }
                    listJson.columns = userPref.columns;
                    appendCheckBoxColumn(listJson);
                    sortColumns(listJson);
                    const selectedColsFromView = filterJson?.selectedColumns || [];
                    if (selectedColsFromView.length) {
                        const resolvedVisible = selectedColsFromView
                            .map(sel => listJson.columns.find(col => col.id === sel.columnId)
                                || (sel.columnQueryName ? listJson.columns.find(col => col.queryName === sel.columnQueryName) : undefined))
                            .filter(Boolean);
                        listJson['visibleCols'] = resolvedVisible.length ? resolvedVisible : listJson.columns.slice(0, userPref.maxNumberOfColumns || 8);
                    } else {
                        listJson['visibleCols'] = listJson.columns.slice(0, userPref.maxNumberOfColumns || 8);
                    }
                    listJson.maxNumberOfColumns = userPref.maxNumberOfColumns || 8;
                    listJson = commonUtil.attachColmnGrpObjFromVisibleCols(listJson);
                    if (data.listViewType) {
                        $rootScope.$emit("fill up list viewType options/value", null, data.listViewType, false);
                    }
                    window.defViewPopulateInstance = $.Deferred();
                    defViewPopulateInstance.promise().then(function () {
                        try {
                            if (userPref && userPref.filterJson && $.parseJSON(userPref.filterJson) && $.parseJSON(userPref.filterJson).filterMap.size) {
                                var obj = $.parseJSON(userPref.filterJson);
                                window.stakeholderObj = obj.filterMap.filterJson[53];
                                window.keyValueObj = {
                                    '456': obj.filterMap.filterJson[456],
                                    '457': obj.filterMap.filterJson[457]
                                }
                                var orderByColumnName = obj.filterMap.orderByColumnName;
                                var orderDirection = obj.filterMap.orderDirection;
                                var pageLength = obj.filterMap.size;
                                var searchText = null;
                                if(obj.filterMap.searchName){
                                    searchText = obj.filterMap.searchName;
                                }
                                //TODO
                                if ($(".docTreeFilter").length==0 && $("#cr").length && typeof $("#cr").dataTable == "function") {
                                    $("#cr").dataTable()._fnLengthChange(pageLength);
                                }
                                listJson["maxRecordOnPage"] = pageLength;
                                listJson["orderByDefaultName"] = orderByColumnName;
                                listJson["orderByDefaultDirection"] = orderDirection;
                                searchText ? listJson["searchName"] = searchText : null;
                            }
                        } catch (e) {
                            if (typeof console != "undefined" && console) {
                                console.log(e);
                            }
                        }
                        if (angular.element("#clause-library").size() > 0) {
                            angular.element('.filter-content').each(function (index) {
                                angular.element(this).populateCustomFilter({
                                    "metaData": filterMetaDataJson,
                                    "data": $.parseJSON(userPref.filterJson).filterMap.filterJson,
                                    "allFilterData": defaultFilterDataJson

                            });
                        })
                        }else {
                            if (!$.isEmptyObject(defaultFilterDataJson))
                                $('.filter-content').populateCustomFilter({
                                    "metaData": filterMetaDataJson,
                                    "data": $.parseJSON(userPref.filterJson).filterMap.filterJson,
                                    "allFilterData": defaultFilterDataJson
                                }, undefined, undefined, undefined, true);

                        }
                        $scope.fixFilterData();
                        if(!_.isEmpty(angular.element(".reportViewContainer")) && $scope.isReportFilter)
                            getNewFilters(true, angular.element(".reportViewContainer"), null, null, true);
                        else
                            getNewFilters(true, angular.element(".originalList.modernListing"), null, null, true);
                        loadTableHeaders();

                        if(userPref.filterJson && JSON.parse(userPref.filterJson) && JSON.parse(userPref.filterJson).filterMap){
                            var fMap = JSON.parse(userPref.filterJson).filterMap;
                            if(fMap && fMap.filterJson && fMap.filterJson['448']){
                                window.filterDataJson['448'] =fMap.filterJson['448'];
                            }
                        }
                        if ($("#clause-library").size() > 0)
                            $rootScope.$emit("loadClausePreferences");
                        var listSc = $('#contentWrap').length ? $('#contentWrap').scope() : null;
                        if($scope.showWorkspaceView)
                            $scope.initialiseWorkspaceListing();
                        else if($scope.docTreeFilterPage){
                            var scope = $(".Filter-detail").scope();
                            loadTree(scope.currentRelationId, undefined, true, scope.data.id.values,true);
                        }
                        else {
                            if($scope.isReportFilter) {
                                loadDataTable(true);
                                getChartNewData(listId, null,listJson);
                            }
                            else modernListing.loadDataTable()
                        }
                        stopLoader();
                            angular.element("#ajaxloading").hide();
                            angular.element("#overlay").remove();
                            $scope.viewModified = false;
                            $rootScope.$broadcast('reCompileFilters');
                            $scope.setPreferredView('byMe');
                        });
                        if (!_.isEmpty(defaultFilterDataJson)) {
                            defViewPopulateInstance.resolve();
                            delete window.defViewPopulateInstance;
                        }
                    }).catch(error => window.systemWarning(error));
                    if (typeof BU != "undefined") {
                        BU.cancelCurrentProcess(true);
                    }
                }

                $scope.appendMissingFilters = (data,specialCase) => {
                    if(data.filterJson) {
                        let filterJSON = !specialCase ? JSON.parse(data.filterJson) : data.filterJson;
                        _.forEach(filterDefaultDataJson, function(value, key) {
                            if(!filterJSON.filterMap.filterJson.hasOwnProperty(key)) {
                                filterJSON.filterMap.filterJson[key] = value;
                            }
                        });
                        if(!specialCase)
                            data.filterJson = JSON.stringify(filterJSON);
                    }
                    return data;
                }

                // This function will help to maintain the checked/un-checked state of [include,does not have] checkboxes.
                $scope.fixFilterData = () => {
                    /*
                    * checkbox-type : 1 => include
                    * checkbox-type : 2 => blank
                    * checkbox-type : 3 => does not have
                    * */
                    let filterJson = _.get(defaultFilterLayoutData,"filterMap.filterJson");
                    if(filterJson) {
                        $.each($("#left_menu .filter-content .extra-options input"), function () {
                            let filterId = $(this).attr('filter-id'),
                                checkboxType = $(this).attr('checkbox-type');
                            if (filterJson[filterId]) {
                                if (checkboxType == '3' && filterJson[filterId].operator == 'not') {
                                    $scope.tickCheckbox(this, filterId);
                                } else if (checkboxType == '1' && filterJson[filterId].operator == 'and') {
                                    $scope.tickCheckbox(this, filterId);
                                }
                            }
                        });
                    }
                }
                $scope.tickCheckbox = (that,filterId) => {
                    $('.extra-options-input[filter-id = "'+filterId+'"]').prop('checked', false);
                    $(that).prop('checked', false);
                    that.checked = true;
                }
                $scope.setViewAsDefault = (e, view) => {
                    e.stopPropagation();
                    e.preventDefault();
                    let maxHeaders = angular.element("#cr:visible>thead th").size();
                    let pref = {};
                    if ($("#clause-library").size() > 0 && (window.listViewTypeSelected.id == 2)) {
                        let reqData = stringify_datatable_json(true);
                        let reqDataJson = jQuery.parseJSON(reqData);
                        let filterJsonForCategories = getNewFilters(false, $("#left_menu"));
                        reqDataJson.filterMap.filterJson = filterJsonForCategories;
                        reqDataJson.filterMap.offset = 0;
                        reqDataJson.filterMap.limit = 200;
                        reqDataJson.filterMap.orderByColumnName = null;
                        reqDataJson.filterMap.orderDirection = null;
                        reqData = JSON.stringify(reqDataJson);
                        pref.filterJson = reqData;
                        pref.maxNumberOfColumns = 20;
                    } else {
                        getNewFilters(false, angular.element(".originalList.modernListing"));
                        pref.filterJson = stringify_datatable_json(false);
                        pref.maxNumberOfColumns = maxHeaders || 8;
                    }
                    if ($scope.defaultView && !view) {
                        flag = false;
                        pref.id = $scope.defaultView.id;
                        pref.name = $scope.defaultView.name;
                        pref.publicVisibility = ["Shared By Me", "Shared With Me"].indexOf($scope.defaultView.visibility) > -1 ? true : false;
                    } else {
                        pref.id = view.id;
                        pref.name = view.name;
                        pref.publicVisibility = ["Shared By Me", "Shared With Me"].indexOf(view.visibility) > -1 ? true : false;
                        flag = true;
                        if (!$scope.isReportFilter) {
                            commonUtil.removePinnedElement(view.id);
                        }
                    }
                    pref.listId = listId;
                    angular.element(this).closest('.preferViewSection').parent('li').addClass('selected');
                    pref.listViewType = window.listViewTypeSelected;
                    if (pref.listViewType)
                        delete pref.listViewType.$$hashKey;

                    pref.columns = listJson.columns;


                    const url = addtStamp(apiVersioning.getApiDynamicVersion($scope.urlController) + listId + "/userpreferences/saveDefaultUserPreference?preferenceId=" + pref.id + "&isDefault=" + flag);
                    if (listId && pref.id) {
                        $http.post(url).then(function successCallback(data) {
                            if (data && data.message != undefined && data.message != null) {
                                SirionUtils.openSirionDialogs({popupType: 'alert', str: data.message, heading: intl_msg[24153]});
                            } else {
                                const isAskMiraPage = window.conditionCheck?.isAskMiraPage();
                                const payload = isAskMiraPage ? { search3Dot0: true } : undefined; //send this object as payload for AskMira page
                                let url = addtStamp(apiVersioning.getApiDynamicVersion($scope.urlController) + listId + "/userPreference");
                                $http.post(url, payload).then(function successCallback(response) {
                                    if (response.status == 200) {
                                        let data = response.data;
                                        $scope.updateViewListing(data, 1);
                                        setTimeout(function () {
                                            angular.element(".disabledClick").removeClass("disabledClick");
                                            if (!_.isEmpty($scope.currentView)) {
                                                angular.element("li[data-mod-id=" + $scope.currentView.id + "]").addClass('disabledClick');
                                                $scope.showResetView = true;
                                            } else {
                                                angular.element(".resetView").addClass('disabledClick');
                                                $scope.showResetView = false;
                                            }
                                        });

                                        if (view && view.visibility === "Shared With Me") {
                                            Toaster.create(parseStr(intl_msg[7744], "<strong>" + view.name + "</strong>"),{iconClass:"icon-Information_filled"});
                                        } else if(!view) {
                                            Toaster.create(intl_msg[7745],{iconClass:"icon-Information_filled"});
                                        }else {
                                            Toaster.create(parseStr(intl_msg[7746], "<strong>" + view.name + "</strong>"),{iconClass:"icon-Information_filled"});
                                        }
                                    }
                                    stopLoader();$(".modTooltip").remove();
                                });
                            }
                        }).catch(error => window.systemWarning(error));
                    } else {
                        Toaster.create(intl_msg[28867]);
                    }

                }


                $scope.unpinView = (e, view) => {
                    e.stopPropagation();
                    view.pinned = false;
                    $(".pin_view_node").removeClass("active");
                    $(".pinned_views").removeClass("not_modified");
                    $http.post(apiVersioning.getApiDynamicVersion("listRenderer_filterController")+ listId + "/" + view.id + "/deletePinPreference").then(function successCallback(d) {
                        $scope.setPreferenceData(_.without($scope.preferenceDataItems, _.find($scope.preferenceDataItems, {
                            id: view.id
                        })));
                        $('li[data-mod-id="' + view.id + '"]').find(".pin").removeClass("icon-unpin").addClass('icon-pin');
                        $('li[data-mod-id="' + view.id + '"]').find(".pin").attr("data-mod-title", intl_msg[25735]);
                        view.pinned = false;
                        $(".modTooltip").remove();
                        $scope.$$postDigest(function () {
                            commonUtil.setListTableHeight();
                        })
                    })
                }

                $scope.pinView = (e, view) => {
                    e.stopPropagation();
                    let pref = view;
                    let itemIndex = $scope.allViews.findIndex(function (v) {
                        return v.id === view.id;
                    });
                    view.pinned = true;
                    $scope.allViews[itemIndex] = view;
                    let url = apiVersioning.getApiDynamicVersion($scope.urlController) + listId + "/" + pref.id + "/pinPreference";
                    $http.post(url).then(function successCallback(d) {
                        pref.pinned = true;
                        let s = $('#contentWrap').scope();
                        s.preferenceDataItems.splice(0, 0, pref);
                        if (!s.$$phase) {
                            s.$apply();
                        }
                        angular.element(e).addClass('icon-unpin').removeClass('icon-pin').attr('data-mod-title', intl_msg[25736]);
                        if ($("li.disabledClick[data-mod-id=" + pref.id + "]").length) {
                            commonUtil.markActiveView(pref.id);
                        }
                        $scope.$$postDigest(function () {
                            commonUtil.setListTableHeight();
                        })
                    });
                }

                $scope.deletePreference = (e, view) => {
                    e.stopPropagation();
                    let name = view.name
                    let publicVisibility = ["Shared By Me", "Shared With Me"].indexOf(view.visibility) > -1 ? true : false;
                    SirionUtils.openSirionDialogs({
                        popupType: 'confirm',
                        str: intl_msg[6488],
                        heading: intl_msg[25772],
                        yesCbFn: function () {
                            /* if (_.isEmpty($scope.defaultView)) {
                                 angular.element(".reset").click();
                             }
                             else  {
                                 // angular.element("li[data-mod-id=" + $scope.defaultView.id + "]").trigger('click');
                                 $scope.loadView(e,$scope.defaultView);
                             }*/
                            var customListId = listId, pref = {};

                            let url = apiVersioning.getApiDynamicVersion($scope.urlController) + customListId + "/deleteUserPreference?preferenceId=" + view.id + "&publicVisibility=" + publicVisibility
                            $http.post(url).then(function successCallback(response) {
                                if($scope.currentView?.id == view.id){
                                    $scope.setToDefaultFilters();
                                }
                                let status = response.status;
                                if(status == 200){
                                    let data = response.data;
                                    stopLoader();
                                    commonUtil.removePinnedElement(view.id);
                                    $scope.updateViewListing(data,1);
                                    if(!_.isEmpty($scope.defaultView)){
                                        // $(".currentView").html($scope.defaultView.name);
                                        $scope.currentView = $scope.defaultView;
                                        $scope.loadView(e,$scope.defaultView);
                                    } else{
                                        $scope.currentView = "";
                                        // angular.element(".reset").click();
                                    }
                                    angular.element("#cancelSettings").length && $scope.cancelSetting(e);

                                    if (data.length == 0) {
                                        setTimeout(function () {
                                            angular.element(".reset").click();
                                        });
                                    }
                                    Toaster.create(intl_msg[23549]);
                                } else{
                                    if (status == 700) {
                                        SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[23603], heading: intl_msg[24153]});
                                        stopLoader();
                                    }
                                }
                            });

                        },
                        noCbFn: function () {
                            return false;
                        }
                    });
                }

                $scope.nameChangeHandler = function() {
                  if(!$scope.nameToSave.value)
                      $scope.nameError = intl_msg[23544];
                  else if($scope.nameError && $scope.nameToSave.value.length<256)
                        $scope.nameError = false;
                };

                $scope.saveSetting = (e) => {
                    $scope.isDirty = true;
                    $scope.viewModified = false;
                    var name = $scope.nameToSave.value.trim();
                    var customListId = listId, pref = {};
                    var result = regexForSpecial.test(name);
                    if (name == "") {
                        //Toaster.create(intl_msg[23544]);
                        $scope.nameError = intl_msg[23544];
                        return false;
                    } else if (result == false) {
                        $scope.nameError = intl_msg[23545];
                        $scope.nameToSave = {'value': ""};
                        return false;
                    } else if (name == intl_msg[23718]){
                        $scope.nameError = intl_msg[23605];
                        $scope.nameToSave = {'value': ""};
                        return false;
                    }
                    if (name != "") {
                        var maxHeaders = angular.element("#cr:visible>thead th").size();
                        var listSc = $('#contentWrap').length ? $('#contentWrap').scope() : null;
                        if (angular.element("#clause-library").size() > 0 && (window.listViewTypeSelected.id == 2)) {
                            if (listSc && listSc.showWorkspaceView)
                                var reqData = stringify_datatable_json(true, undefined, undefined, true);
                            else
                                var reqData = stringify_datatable_json(true);
                            var reqDataJson = jQuery.parseJSON(reqData);
                            var filterJsonForCategories = getNewFilters(false, $("#left_menu"),null,null,null,true);
                            reqDataJson.filterMap.filterJson = filterJsonForCategories;
                            reqDataJson.filterMap.offset = 0;
                            reqDataJson.filterMap.limit = 200;
                            reqDataJson.filterMap.orderByColumnName = null;
                            reqDataJson.filterMap.orderDirection = null;
                            reqData = JSON.stringify(reqDataJson);
                            pref.filterJson = reqData;
                            pref.maxNumberOfColumns = 20;
                        } else {
                            getNewFilters(false, angular.element(".originalList.modernListing"),null,null,null,true);
                            if (listSc && listSc.showWorkspaceView)
                                pref.filterJson = stringify_datatable_json(false, undefined, undefined, true);
                            else
                                pref.filterJson = stringify_datatable_json(false);
                            pref.maxNumberOfColumns = maxHeaders || 8;
                        }

                        if(window.reactFilterLoaded){
                            pref.filterJson = JSON.parse(pref.filterJson);
                            pref.filterJson.filterMap.filterJson = window.processedFilterData;

                            let payload = window.payload && window.payload.filterMap && window.payload.filterMap.filterJson && window.payload.filterMap.filterJson;
                            if(!_.isEmpty(payload)) {
                                _.map(payload, _payload => {
                                    let id = _payload.filterId;
                                    pref.filterJson.filterMap.filterJson[id] = _payload;
                                });
                            }
                            pref.filterJson = JSON.stringify(pref.filterJson);
                        }



                        // Set searchName filter value
                        if($scope.searchTextForDT && !!$scope.searchTextForDT.value){
                            pref.filterJson = JSON.parse(pref.filterJson);
                            pref.filterJson.filterMap.searchName = $scope.searchTextForDT.value;
                            pref.filterJson = JSON.stringify(pref.filterJson);
                        }

                        if (listSc && listSc.showWorkspaceView) {
                            var filterJsonObj = JSON.parse(pref.filterJson);
                            pref.maxNumberOfColumns = 3;
                        }
                        pref.listId = customListId;
                        pref.name = name;
                        flag = true;
                        pref.columns = listJson.columns;
                        pref.listViewType = window.listViewTypeSelected;
                        if (pref.listViewType)
                            delete pref.listViewType.$$hashKey;
                        setCheckBoxObject(listJson);
                        $scope.viewTypeToSave === 'public' ? pref.publicVisibility = true : pref.publicVisibility = false;
                    // Add search3dot0 flag for AskMira page
                    if (window.conditionCheck?.isAskMiraPage()) {
                        pref.search3Dot0 = true;
                        if ($scope.pinnedColumnsToUpdate) {
                            pref.pinnedColumns = $scope.pinnedColumnsToUpdate;
                            delete $scope.pinnedColumnsToUpdate;
                        }
                    }

                    if (name.length < 256) {
                        var isExist = false;
                        let nm = $scope.allViews.find(function (v) {
                            return v.visibility === 'My View' && v.name.toLowerCase() == name.toLowerCase();
                        });
                        if(!_.isEmpty(nm)){
                            isExist = true;
                        }
                        if (isExist) {
                            $scope.nameError = intl_msg[23552];
                            $scope.nameToSave = {'value':""};
                            return;
                        } else {
                           let url = apiVersioning.getApiDynamicVersion($scope.urlController) + customListId + "/userpreferences/save";
                            return $http.post(url,JSON.stringify(pref))
                                .then( function (response) {
                                    let status = response.status;
                                    $scope.resetDocTreeSaveBanner(false);
                                    if(status == 200){
                                        let data = response.data;
                                        if($rootScope.isCorpusPage) {
                                            window.userListMetaData = data;
                                            window.isArkSirionViewPresent = true;
                                        }
                                        commonUtil.markActiveView();
                                        $scope.viewTypeToSave==='public' ? pref.publicVisibility = true : pref.publicVisibility = false;
                                        $scope.updateViewListing(data);
                                        var viewVal = $scope.nameToSave.value.trim();
                                        $scope.viewTypeToSave = 'private';
                                        $scope.radio.saveType.value = 'private';
                                        $scope.nameToSave = {'value':""};
                                        $scope.currentView = $scope.allViews.find(function (v) {
                                            return v.name == name;
                                        });
                                        if(!$scope.currentView.isdefault){
                                            $scope.showResetView = true;
                                        }
                                        $scope.radio.viewType.value = 'byMe';
                                        stopLoader();
                                        $("body").click();
                                        if(!$rootScope.isCorpusPage) {
                                            Toaster.create(intl_msg[23548]);
                                        }
                                        setTimeout(function(){
                                            angular.element(".disabledClick").removeClass("disabledClick");
                                            angular.element("li[data-mod-id=" + $scope.currentView.id + "]").addClass('disabledClick');
                                        },0);
                                    } else {
                                        if (status == 810) {
                                            $scope.nameError = intl_msg[23547];
                                            $scope.nameToSave = {'value':""};
                                        }
                                        else if (status == 600) {
                                            $scope.nameError = intl_msg[23552];
                                            $scope.nameToSave = {'value':""};
                                        }
                                        else if (status == 700) {
                                            SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[7748], heading: intl_msg[24153]});
                                        }
                                        else if(status==811) {
                                            $scope.showLimitExceedMessage = (intl_msg[28988]).replace("%s", response.data[0]);
                                            SirionUtils.openSirionDialogs({popupType: 'alert', str: (intl_msg[28988]).replace("%s", response.data[0]), heading: intl_msg[24153]});
                                        }
                                        stopLoader();

                                }
                        }).catch(error => window.systemWarning(error));
                    }
                    }else {
                        $scope.nameError = intl_msg[23547]
                        stopLoader();
                    }
                }
            }

                $scope.setVisibilityOfViewToSave = (viewType) => {
                    if (viewType == "private") {
                        $scope.viewTypeToSave = 'private';
                        // angular.element('#privateBtnRadio').prop("checked", true);
                        $scope.radio.saveType.value = 'private';
                    } else {
                        $scope.viewTypeToSave = 'public';
                        // angular.element('#publicBtnRadio').prop("checked", true);
                        $scope.radio.saveType.value = 'public';
                    }
                }

            $scope.editView = (e,view) =>{
                $scope.editViewObj = view;
                editViewArr[0] = view.name;
                editViewArr[1] =["Shared By Me", "Shared With Me"].indexOf(view.visibility) > -1 ? true : false;
                editViewArr[2] = view.id;
                $scope.nameToSave.value = view.name;
                setTimeout(function () {
                    $scope.loadView(e,view);
                });
                var _editViewText = intl_msg[29085]||"Edit View";
                angular.element(".viewSection.create").addClass("editMode").find(".title").html(_editViewText);
                angular.element('.viewSection.create .title.list-toolbar-text').attr('title',_editViewText);
                angular.element("body").click();
                setTimeout(function () {
                    var elem = $(".viewSection.create");
                    $scope.radio.saveType.value = editViewArr[1] ? 'public' : 'private';
                    angular.element(".viewSection").removeClass("selected");
                    elem.click();
                    elem.addClass('selected');
                    elem.addClass("clickOnBodyClick");
                    elem.find(".createView.search").focus();
                    elem.find(".createView.search").val(editViewArr[0]);
                    $scope.saveMode = false;
                    $scope.updateMode = true;
                    angular.element(".disabledClick").removeClass("disabledClick");
                    angular.element("li[data-mod-id=" + view.id + "]").addClass('disabledClick');
                }, 500);
                $(".modTooltip").remove();
            }

            $scope.setToDefaultFilters = () => {
                $('#filterDiv').scope().clickOnResetBtn();
            }

            $scope.cancelSetting = (e) =>{
                e.stopPropagation();
                angular.element(this).closest(".createViewDD").find(".search").val("");
                angular.element(".viewSection.create").removeClass("editMode")
                angular.element(".viewSection.create .title").attr('title',intl_msg[27944]).html(intl_msg[27944]);
                angular.element("#viewTypePrivate").prop("checked", true);
                setTimeout(function () {
                    angular.element("body").click();
                    $scope.updateMode = false;
                    $scope.saveMode = true;
                    $scope.nameToSave = {'value':""};
                    if($scope.viewModified){
                        if(!_.isEmpty($scope.defaultView)){
                            $scope.loadView(e,$scope.defaultView);
                        } else {
                            BU.cancelCurrentProcess(true);
                            angular.element(".reset").click();
                        }
                        $scope.viewModified = false;
                    }
                }, 100);
            $(".modTooltip").remove();}

            $scope.updateSetting = (e,updateCurrentView, options) =>{
                e.stopPropagation;
                $scope.openDocTreeSaveDD(false);
                if(updateCurrentView){
                    $scope.resetDocTreeSaveBanner(false);
                }
                alreadySavedView = false;
                var maxHeaders = $("#cr:visible>thead th").size();

                var customListId = listId, pref = {};

                    if ($("#clause-library").size() > 0 && (window.listViewTypeSelected.id == 2)) {
                        var reqData = stringify_datatable_json(true, null, null, null, null, null, options?.skipColumnSort);
                        var reqDataJson = jQuery.parseJSON(reqData);
                        var filterJsonForCategories = getNewFilters(false, $("#left_menu"));
                        reqDataJson.filterMap.filterJson = filterJsonForCategories;
                        reqDataJson.filterMap.offset = 0;
                        reqDataJson.filterMap.limit = 200;
                        reqDataJson.filterMap.orderByColumnName = null;
                        reqDataJson.filterMap.orderDirection = null;
                        reqData = JSON.stringify(reqDataJson);
                        pref.filterJson = reqData;
                        pref.maxNumberOfColumns = 20;
                    } else {
                        getNewFilters(false, $(".originalList.modernListing"));
                        pref.filterJson = stringify_datatable_json(false, null, null, null, null, null, options?.skipColumnSort);
                        pref.maxNumberOfColumns = maxHeaders || 8;
                    }
                    pref.listId = customListId;
                    let name = "";
                    if (updateCurrentView) {
                        if ($scope.currentView) {

                            name = $scope.currentView.name;
                        }
                    } else {

                    // name = $("#settingName").val().trim();
                    name = $scope.nameToSave.value.trim();
                }
                if (name == "") {
                    stopLoader();
                    $scope.isDirty = true;
                    $scope.nameError = intl_msg[23544];
                    return false;
                }
                let viewType = "";

                if(updateCurrentView){
                    pref.id = $scope.currentView.id;

                } else {
                    $scope.currentView = $scope.editViewObj;
                    pref.id = $scope.editViewObj.id;

                }
                let prefId =pref.id;
                pref.name = name;
                flag = true;
                pref.columns = listJson.columns;
                pref.listViewType = window.listViewTypeSelected;
                if (pref.listViewType){
                    delete pref.listViewType.$$hashKey;
                }
                setCheckBoxObject(listJson);
                pref.publicVisibility = $scope.radio.saveType.value == 'public' ? true : false;
                setTimeout(function(){commonUtil.renameCurrentActiveView(pref.name, pref.id);});
                let postJson = $.parseJSON(pref.filterJson);
                delete postJson.filterMap.searchName;

                var searchText = $(".listingSearchBar").val();
                if (searchText && postJson.filterMap) {
                    postJson.filterMap.searchName = searchText;
                }

                if(window.reactFilterLoaded){
                    postJson.filterMap.filterJson = window.processedFilterData;


                    let payload = window.payload && window.payload.filterMap && window.payload.filterMap.filterJson;
                    if(!_.isEmpty(payload)) {
                        _.map(payload, _payload => {
                            let id = _payload.filterId;
                            postJson.filterMap.filterJson[id] = _payload;
                        });
                    }
                }

                pref.filterJson = JSON.stringify(postJson);
                $scope.initialPrefViewFilterDataObj = JSON.parse(pref.filterJson).filterMap.filterJson;
                
                // Add pinned columns and search3Dot0 flag for AskMira page
                if (window.conditionCheck?.isAskMiraPage()) {
                    pref.search3Dot0 = true;
                    if ($scope.pinnedColumnsToUpdate) {
                        pref.pinnedColumns = $scope.pinnedColumnsToUpdate;
                        delete $scope.pinnedColumnsToUpdate;
                    }
                }
                
                let url =  apiVersioning.getApiDynamicVersion($scope.urlController) + customListId + "/userpreferences/update";
                $http.post(url,pref).then(function successCallback (data) {
                    if(data.data) {$scope.viewModified = false;
                    $scope.cancelSetting(e);
                    angular.element(".viewSection").find(".DropdownBox").css("opacity", 0).css("visibility", "hidden");
                    $scope.updateViewListing(data.data);
                    angular.element(".disabledClick").removeClass("disabledClick");
                    $("li[data-mod-id=" + prefId + "]").addClass("disabledClick");
                    $scope.currentView= data.data.find(function (v) {
                            return v.name ==name;
                    });
                    stopLoader();
                    if(!window.conditionCheck?.isAskMiraPage()) {
                        Toaster.create(intl_msg[23546]);
                    }
                    $scope.nameToSave = {'value':""};
                }
            }).catch(error => window.systemWarning(error));
            }


                $scope.pinOrUnpinView = (e, view) => {
                    if (view.pinned) {
                        $scope.unpinView(e, view);
                    } else {
                        $scope.pinView(e, view);
                    }
                }

                $scope.resetDocTreeSaveBanner = function(val) {
                    $scope.docTreeFilterApplied = val;
                }

                $scope.getDropdownText = (viewType) => {
                    if ($scope.allViews) {
                        if (viewType === 'private') {
                            return intl_msg[23713] + " (" + $scope.allViews.filter(function (view) {
                                return view.visibility === 'My View'
                            }).length + ")";
                        } else {
                            return intl_msg[23714] + " (" + $scope.allViews.filter(function (view) {
                                return view.visibility === 'Shared By Me'
                            }).length + ")";
                        }
                    }

                }

                $scope.removeView = (e) => {
                    e.stopPropagation();
                    commonUtil.markActiveView();
                    BU.cancelCurrentProcess(true);
                    $scope.searchTextForDT = {value:'',debounce:0};
                    listJson.searchName = '';
                    if (!_.isEmpty($scope.defaultView)) {
                        $scope.loadView(e, $scope.defaultView);
                    } else {
                        setTimeout(function () {
                            angular.element(".reset").click();
                        });
                        $scope.currentView = {};
                        $scope.showResetView = false;
                    }
                    $(".modTooltip").remove();
                }

                $scope.openGroups = () => {
                    angular.element("#privateDiv").show();
                    angular.element("#publicDiv").show();
                }
                var resetViewCleanup = $rootScope.$on('resetCurrentView', function () {
                    $scope.currentView = {};
                    $scope.showResetView = false;
                })

                $scope.$on("$destroy", function (e) {
                    resetViewCleanup();
                });
                $scope.openDocTreeSaveDD = function(val) {
                    // closing save filter dd if save banner is visible
                    if($scope.showSaveFiltersDD && val){
                        $scope.showSaveFiltersDD = false;
                    }
                    if($scope.showPageService.retObj.showDocTreeFilterPanel && val){
                        $scope.showPageService.retObj.showDocTreeFilterPanel = false;
                    }
                    $scope.openSaveDropDown = val;
                }
                $scope.toggleDocTreeSaveFilters = function(event,val){
                    if(event && _.isEmpty(defaultFilterDataJson)){
                        $scope.showPageService.initDocTreeFilters(event,$scope.reactDocTreePermission.enabled);
                    }
                    $scope.showSaveFiltersDD = !val;
                }
                $scope.expandClickHandler = function (event) {
                    if($scope.isReportFilter) {
                        event.stopImmediatePropagation();
                           if(angular.element(event.currentTarget).hasClass('selected') != true) {
                               $scope.toggleFilterPanel(false,undefined);
                               $scope.initToggleReportFilters(event).then(function () {
                                   $scope.expandHandler(event)
                               });
                           }else{
                               angular.element(event.currentTarget).removeClass("selected");;
                               angular.element(event.currentTarget).find(".DropdownBox").css({"opacity": 0, "visibility": "hidden", "display": "none", "z-index": -1});
                           }

                    }else if($scope.docTreeFilterPage) {
                        $scope.openSaveView(event,false);
                        $scope.showPageService.initDocTreeFilters(event);
                    }else  {
                        if(event.currentTarget.id === "faView"){
                            $scope.initFilters(event);
                            if((angular.element(".viewSection").hasClass('editMode'))){
                                angular.element(".viewSection.create").removeClass("editMode");
                                angular.element(".viewSection.create .title").attr('title',intl_msg[27944]).html(intl_msg[27944]);
                                $scope.updateMode = false;
                                $scope.saveMode = true;
                                $scope.nameToSave = {'value':""};
                                $scope.viewModified = false;
                            }
                        } else if(event.currentTarget.id === "createBtn")
                            $scope.openSaveView(event,false)
                    }
                }


                $scope.expandHandler = function (e) {
                    var that = e.currentTarget;
                    if (e.originalEvent || $(that).hasClass("editMode")) {
                        $('[column-group]').remove();
                        $(".viewSection, .columnsGroupButton").removeClass("selected");
                        $(that).addClass("selected");
                        $(".DropdownBox, .reportColumnContainer").css({"opacity":0,"visibility":"hidden","display":"none","z-index":-1});
                        if($(that).hasClass("workSpacebtn") == false || (e.target && e.target.tagName.toLowerCase() != "li")){
                            setTimeout(function () {
                                $(that).find(".DropdownBox").css({"opacity":1,"visibility":"visible","display":"block","z-index":999999});
                            },0)
                        }
                    }
                }

                $scope.openSaveView = function(e,hide){
                    var scope  = $scope;
                    if($scope.docTreeFilterPage) {
                        scope = $(".Filter-detail").scope();
                    }
                    if(!scope){
                        return;
                    }
                    if(scope.private == undefined || hide){
                        scope.private =true;
                    }
                    var createViewDDRef = e?angular.element(e.target).closest(".createViewDD"):undefined;
                    if(e && createViewDDRef.length){
                        return;
                    }
                    if(createViewDDRef && createViewDDRef.length || hide){
                        $(".viewSection .create").removeClass("selected");
                        return;
                    }
                    if(!e){
                        return;
                    }

                }
            }
        }
    }]);
